import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import vueI18n from './lang';
import { cookie } from "./utils/common";
import { lockBodyScroll } from './directives/lockBodyScroll';

import "./permission"

import 'ant-design-vue/es/message/style/css';
import 'ant-design-vue/es/notification/style/css';
import 'ant-design-vue/es/badge/style/css';

// 引入Jackery Design System 设计系统样式，js暂时使用CDN引入
import "@jackery/design-system/dist/index.css"

// reset style
import './assets/main.less';
import './utils/CDP.js'

import '@unocss/reset/tailwind-compat.css'
import 'virtual:uno.css'

// 引入Jackery Business Components 业务组件库
import "@jackery/biz-components/dist/index.css"
import "@jackery/biz-components/dist/index.es.js"


// 设置语言
function setLanguage() {
  const _lang = cookie.get('_jk_lang') || localStorage.getItem('JACKERY_ID_LANG') || 'en-US';
  document.querySelector('html').setAttribute('lang', _lang.substring(0, 2));
  return _lang;
}

// 动态加载日站字体文件
// function loadFontIfNeeded(lang) {
//   if (lang === 'ja-JP') {
//     return new Promise((resolve, reject) => {
//       const link = document.createElement('link');
//       link.rel = 'stylesheet';
//       link.href = '/jp-font.css';
//       link.onload = resolve; // 字体加载完成后 resolve
//       link.onerror = reject; // 字体加载失败后 reject
//       document.head.appendChild(link);
//     });
//   }
//   return Promise.resolve(); // 如果不是日语，直接 resolve
// }

// 初始化应用
function initializeApp() {
  // jackery_account_env
  if (import.meta.env.MODE === 'production') { window.jackery_account_env = "prod" }
  if (import.meta.env.MODE === 'demo') { window.jackery_account_env = "demo" }
  if (import.meta.env.MODE === 'uat') { window.jackery_account_env = "uat" }
  console.info('welcome to jackery. For more information about us, please follow https://www.jackery.com/pages/about-us');

  const app = createApp(App);
  app.directive('lock-body-scroll', lockBodyScroll)
  app.use(store).use(router).use(vueI18n).mount('#app');
}

// 主逻辑
const lang = setLanguage();
initializeApp();
// loadFontIfNeeded(lang)
//   .then(() => {
//     initializeApp();
//   })
//   .catch((error) => {
//     console.error('字体加载失败:', error);
//     initializeApp(); // 即使字体加载失败，也继续初始化应用
//   });

